export enum IdMessage {}

export enum IdRoute {
  ROOT = 'id',
  STICKERS = 'stickers',
  SETTINGS = 'settings',
}
